document.addEventListener('DOMContentLoaded', function () {
  vgInitReveal();
  vgInitFaqOpen();
  vgInitGallery();
  vgInitStickyBar();
  vgInitCountdown();
  vgInitViewers();
  vgInitExitIntent();
  vgInitSmoothAnchors();
  vgInitHeroVideo();
});

function vgInitReveal() {
  var els = document.querySelectorAll('.vg-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('vg-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('vg-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  els.forEach(function (el) { io.observe(el); });
}

function vgInitFaqOpen() {
  document.querySelectorAll('.vg-faq-item').forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      document.querySelectorAll('.vg-faq-item').forEach(function (other) {
        if (other !== item) other.open = false;
      });
    });
  });
}

function vgInitGallery() {
  document.querySelectorAll('[data-vg-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-vg-gallery-main] img');
    var thumbs = gallery.querySelectorAll('[data-vg-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        var alt = thumb.getAttribute('data-alt') || '';
        main.style.opacity = '0';
        setTimeout(function () {
          main.src = full;
          main.alt = alt;
          main.style.opacity = '1';
        }, 150);
        thumbs.forEach(function (t) { t.classList.remove('vg-active'); });
        thumb.classList.add('vg-active');
      });
    });
  });
}

function vgInitStickyBar() {
  var bar = document.querySelector('[data-vg-sticky-bar]');
  var trigger = document.querySelector('[data-vg-sticky-trigger]');
  if (!bar || !trigger) return;
  var stickyBtn = bar.querySelector('[data-vg-sticky-btn]');
  var mainForm = document.querySelector('[data-vg-main-form]');
  if (stickyBtn && mainForm) {
    stickyBtn.addEventListener('click', function () {
      var mainBtn = mainForm.querySelector('[type="submit"]');
      if (mainBtn) mainBtn.click();
    });
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      bar.classList.toggle('vg-sticky-visible', !visible);
    }, { rootMargin: '0px 0px -20% 0px' });
    io.observe(trigger);
  }
}

function vgInitCountdown() {
  document.querySelectorAll('[data-vg-countdown]').forEach(function (el) {
    var hoursEl = el.querySelector('[data-vg-h]');
    var minsEl = el.querySelector('[data-vg-m]');
    var secsEl = el.querySelector('[data-vg-s]');
    if (!hoursEl || !minsEl || !secsEl) return;

    function getTarget() {
      var now = new Date();
      var target = new Date(now);
      target.setHours(23, 59, 59, 999);
      return target;
    }

    function tick() {
      var now = new Date();
      var target = getTarget();
      var diff = Math.max(0, target - now);
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      hoursEl.textContent = String(h).padStart(2, '0');
      minsEl.textContent = String(m).padStart(2, '0');
      secsEl.textContent = String(s).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  });
}

function vgInitViewers() {
  document.querySelectorAll('[data-vg-viewers]').forEach(function (el) {
    function setCount() {
      var count = 9 + Math.floor(Math.random() * 14);
      el.textContent = count + ' personas viendo este producto ahora';
    }
    setCount();
    setInterval(setCount, 14000);
  });
}

function vgInitExitIntent() {
  var overlay = document.querySelector('[data-vg-exit-overlay]');
  if (!overlay) return;
  var closeBtn = overlay.querySelector('[data-vg-exit-close]');
  var shown = sessionStorage.getItem('vgExitShown');
  var isMobile = window.matchMedia('(max-width: 749px)').matches;

  function show() {
    if (sessionStorage.getItem('vgExitShown')) return;
    overlay.classList.add('vg-exit-visible');
    sessionStorage.setItem('vgExitShown', '1');
  }
  function hide() { overlay.classList.remove('vg-exit-visible'); }

  if (closeBtn) closeBtn.addEventListener('click', hide);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) hide(); });

  if (!isMobile && !shown) {
    document.addEventListener('mouseout', function (e) {
      if (e.clientY < 10 && !e.relatedTarget) show();
    });
  } else if (isMobile && !shown) {
    var lastScroll = 0;
    window.addEventListener('scroll', function () {
      if (window.scrollY < lastScroll && window.scrollY > 400) show();
      lastScroll = window.scrollY;
    }, { passive: true });
  }
}

function vgInitSmoothAnchors() {
  document.querySelectorAll('a[href^="#vg-"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
}

function vgInitHeroVideo() {
  var video = document.querySelector('[data-vg-hero-video]');
  if (!video) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || navigator.webkitConnection || navigator.mozConnection;
  var lowData = conn && (conn.saveData || /^(slow-2g|2g)$/.test(conn.effectiveType || ''));

  if (reducedMotion || lowData) return;

  if (!('IntersectionObserver' in window)) {
    video.play().catch(function () {});
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        video.play().catch(function () {});
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.25 });
  io.observe(video);
}
